import { app } from "@/config/env";
import {
  AD_TRACKING_COOKIE_KEY,
  CLICK_IDS,
  GA_ID,
  LAST_GA_ID,
} from "@/constants";
import { getCookie, setCookie } from "@/lib/cookie";
import { readClickIdsFromStorage } from "@/lib/identifiers";
import { rudderanalytics } from "@/lib/rudderstack";
import { PosthogAnalytics } from "../posthog";

const LUCE_WEBSITE_URL = window.location.origin;

const fetchTrackingUrl = async (url: URL): Promise<string> => {
  const response = await fetch(
    `${app.PUBLIC_API_ENDPOINT.replace("/graphql", "")}/api/v1/service/url_shortener/generate`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ url, category: "Tracking" }),
    },
  );

  if (!response.ok) {
    throw new Error("Response failed.");
  }

  const data = (await response.json()) as { shortened_url: string };
  return data.shortened_url;
};

const generateTrackingKey = async () => {
  const gaId = getCookie(GA_ID) || "";
  const rudderstackId = await rudderanalytics.getAnonymousId();
  const clickIds = await readClickIdsFromStorage();
  const { session_id, distinct_id } = PosthogAnalytics.getIdentifiers();

  try {
    const url = new URL(LUCE_WEBSITE_URL);
    url.searchParams.set("gaid", gaId);
    url.searchParams.set("rudderstackid", rudderstackId);

    CLICK_IDS.forEach((param) => {
      url.searchParams.set(param, clickIds[param] || "");
    });

    if (session_id && distinct_id) {
      url.searchParams.set("posthog_session_id", session_id);
      url.searchParams.set("posthog_distinct_id", distinct_id);
    }

    const trackingUrl = await fetchTrackingUrl(url);
    const key = new URL(trackingUrl).searchParams.get("origin") || "";
    setCookie(AD_TRACKING_COOKIE_KEY, key);
    setCookie(LAST_GA_ID, gaId);

    return key;
  } catch (error) {
    console.error("Failed to shorten the url:", error);
    return "";
  }
};

export const getTrackingKey = async () => {
  const trackingKey = getCookie(AD_TRACKING_COOKIE_KEY);

  if (trackingKey) {
    return trackingKey;
  }

  return generateTrackingKey();
};

export const embedTrackingUrl = (message: string) => {
  const trackingKey = getCookie(AD_TRACKING_COOKIE_KEY);

  if (trackingKey) {
    message += ` From your page ${LUCE_WEBSITE_URL}?origin=${trackingKey}`;
  }

  return message;
};
